module.exports = __webpack_public_path__ + "static/media/fullscreen.b26a844e.svg";